// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1-AVI","col":"styles_col__2SBjf"};